import React, { useEffect, useState } from "react";
import { redirect, useNavigate } from "react-router-dom";
import {
    FiSearch,
    FiChevronRight,
    FiChevronDown,
    FiFilter,
} from "react-icons/fi";
import { BsFileEarmarkText } from "react-icons/bs";
import { HiOutlineDocumentText } from "react-icons/hi";
import Logo from "../../../assets/home/logo.svg";
import { FaCheck } from "react-icons/fa6";
import SscLogo from "../../../assets/exam/ssc.png";
import PoliceLogo from "../../../assets/exam/dehli.png";
import RailwayLogo from "../../../assets/exam/rrb.png";
import IbLogo from "../../../assets/exam/ib.png";
import UpLogo from "../../../assets/exam/up.png";
import { axiosRequest } from "../../../_config/apiClient";

const PreviousYearPaper = () => {
    const [openFaq, setOpenFaq] = useState(null);
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryLoading, setCategoryLoading] = useState(true);

    const [exams, setExams] = useState([]);
    const [examLoading, setExamLoading] = useState(false);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axiosRequest(
                    "post",
                    "/user/getCategoryList",
                    {},
                    {
                        Authorization: `Bearer ${localStorage.getItem("user")}`,
                    },
                );

                const list = response?.data?.list || [];
                setCategories(list);

                if (list.length > 0) {
                    setSelectedCategory(list[0]);
                }
            } catch (error) {
                console.error("Category API error:", error);
            } finally {
                setCategoryLoading(false);
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        if (!selectedCategory?._id) return;

        const fetchExams = async () => {
            setExamLoading(true);
            try {
                const res = await axiosRequest(
                    "post",
                    "/user/getExamList",
                    {
                        category: selectedCategory._id,
                        pageNo: 1,
                        size: 20,
                    },
                    {
                        Authorization: `Bearer ${localStorage.getItem("user")}`,
                    },
                );

                const list = res?.data?.list || [];
                setExams(list);
            } catch (err) {
                console.error("Exam API error", err);
                setExams([]);
            } finally {
                setExamLoading(false);
            }
        };

        fetchExams();
    }, [selectedCategory]);

    const getExamData = (categoryName) => {
        const generate = (title, subtitle) =>
            Array(9).fill({
                title,
                subtitle,
                tests: 245,
                questions: 245,
                papers: 245,
            });

        switch (categoryName) {
            case "Banking Exam":
                return generate(
                    "SBI PO 2023",
                    "State Bank of India Probationary Officer exam with complete mock test series and previous year papers.",
                );
            case "SSC Exams":
                return generate(
                    "SSC CGL 2023",
                    "Staff Selection Commission Combined Graduate Level exam with tier-1 and tier-2 papers.",
                );
            default:
                return generate(
                    "Mock Exam 2023",
                    "Comprehensive test series and previous year papers for this category.",
                );
        }
    };

    const currentExams = getExamData(selectedCategory?.name);

    const enrolledExams = [
        { name: "SSC CGL", papers: "446 Paper", icon: SscLogo },
        { name: "SSC MTS", papers: "446 Paper", icon: SscLogo },
        { name: "Delhi Police HC", papers: "25 Paper", icon: PoliceLogo },
        { name: "UP Police Const...", papers: "446 Paper", icon: UpLogo },
        { name: "RRB Group D", papers: "549 Paper", icon: RailwayLogo },
        { name: "SSC GD Const...", papers: "410 Paper", icon: SscLogo },
        { name: "Delhi Police MTS", papers: "410 Paper", icon: PoliceLogo },
        { name: "IB MTS", papers: "30 Paper", icon: IbLogo },
    ];

    const faqs = [
        "Why should one go for solving previous years' papers?",
        "Are the previous years' papers enough to Guideare for the recruitment exams?",
        "Where will I get the previous years' papers?",
        "What should I practice more for SSC exams from the previous years' papers?",
        "How many previous years' papers are recommended for candidates to practice?",
        "I am Guidearing for banking exams, will I get IBPS previous years' papers on BaapBola to practice from?",
        "Can I find SSC MTS previous years' papers on BaapBola?",
        "Can I find the previous years' papers for RRB NTPC and RRB Group D recruitment?",
        "I was looking for REET previous years' papers. Will I get it here?",
    ];

    const redirectToExam = (exam) => {
        sessionStorage.setItem("examConfig", JSON.stringify({ sourceType: 'Exam', ...exam }));
        navigate("/exam-instructions");
    };

    return (
        <div className="font-poppins w-full pb-10 min-h-screen bg-[#F5F7FA]">
            {/* 1. Header  */}
            <div className="flex flex-col md:flex-row items-stretch md:items-center gap-4 md:gap-8 mb-6 bg-[#3B8BE3] md:h-[97px] rounded-[8px] py-4 md:py-0">
                <div className="flex items-center gap-3 px-5 py-3 rounded-[8px] md:min-w-[320px]">
                    <div className="bg-[#FFEABF] p-2 rounded-md">
                        <BsFileEarmarkText color="#FFAD33" size={22} />
                    </div>
                    <span className="font-[400] text-white text-[15px] tracking-tight">
                        Previous Year & Memory Based Papers
                    </span>
                </div>

                <div className="relative flex-1 px-[10px] py-[8px] bg-white rounded-[6px] mx-4 md:mx-5">
                    <input
                        type="text"
                        placeholder="Search for your Exam"
                        className="w-full h-[40px] px-[20px] py-[10px] placeholder:text-[#333333] rounded-[6px] border border-[#333333] focus:outline-none focus:border-[#3B8BE3] text-[16px] md:text-[18px] bg-white font-[500] tracking-tight text-[#333333]"
                    />

                    <FiSearch className="absolute right-6 md:right-8 top-1/2 -translate-y-1/2 text-[#333333B2] text-[18px]" />
                </div>
            </div>

            {/* 2. Prime Subscription Banner*/}
            <div className="relative w-full rounded-[20px] overflow-hidden p-6 md:px-10 md:py-8 mb-8 text-white shadow-lg">
                <img
                    src={require("../../../assets/bg.png")}
                    alt="BaapBola Prime Background"
                    className="absolute inset-0 w-full h-full object-cover z-0"
                />

                <div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex-1">
                        <div className="mb-4">
                            <img
                                src={Logo}
                                alt="Logo"
                                className="w-[120px] md:w-[150px] h-auto object-contain drop-shadow-sm"
                            />
                        </div>

                        <h2 className="text-[28px] md:text-[26px] font-[500] mb-4 leading-tight tracking-tight drop-shadow-sm">
                            Unlock all Previous Year Papers with BaapBola Prime Subscription
                        </h2>

                        <div className="border-t border-dashed border-white/50 w-full mb-4"></div>
                        <div className="flex flex-wrap gap-6 text-[14px] font-[500]">
                            <span className="text-white text-[13px]">Also Includes</span>
                            <span className="flex items-center gap-2 drop-shadow-sm">
                                <div className="bg-[#21C11E] rounded-full p-[4.5px] shadow-sm">
                                    <FaCheck className="text-white text-[13px]" />
                                </div>{" "}
                                Prev. Year Papers
                            </span>
                            <span className="flex items-center gap-2 drop-shadow-sm">
                                <div className="bg-[#21C11E] rounded-full p-[4.5px] shadow-sm">
                                    <FaCheck className="text-white text-[13px]" />
                                </div>{" "}
                                Practice
                            </span>
                            <span className="flex items-center gap-2 drop-shadow-sm">
                                <div className="bg-[#21C11E] rounded-full p-[4.5px] shadow-sm">
                                    <FaCheck className="text-white text-[13px]" />
                                </div>{" "}
                                Unlimited Test Re-Attempts
                            </span>
                        </div>
                    </div>
                    <button className="bg-[#21C11E] text-white p-[10px] rounded-[6px] font-[500] text-[14px] hover:bg-green-500 transition-colors whitespace-nowrap shadow-md uppercase tracking-tight">
                        Get Prime Subscription
                    </button>
                </div>
            </div>

            {/* MAIN */}
            <div className="mb-12">
                <div className="mb-6">
                    <h2 className="text-[28px] font-[500] tracking-tightest text-[#333333]">
                        {(!categoryLoading && selectedCategory?.name) || "Loading..."}
                    </h2>

                    <p className="text-[18px] text-[#33333399] mt-1 tracking-tight">
                        Comprehensive study materials, mock tests, and previous year papers
                        for all{" "}
                        {(categoryLoading === false &&
                            selectedCategory?.name?.toLowerCase()) ||
                            "-"}
                    </p>
                </div>

                <div className="w-full bg-white rounded-[10px] border border-[#E0E0E0] mb-12">
                    <div className="flex flex-col lg:flex-row gap-6">
                        {/* SIDEBAR */}
                        <div className="hidden lg:block w-[240px] shrink-0 bg-white shadow-[0_0px_4px_rgba(0,0,0,0.25)] border-[#E0E0E0] rounded-l-[10px] overflow-hidden ">
                            {categories.map((item, i) => (
                                <div
                                    key={i}
                                    onClick={() => setSelectedCategory(item)}
                                    className={`flex justify-between items-start px-[14px] font-[500] py-[16px] rounded-l-[4px] cursor-pointer transition-all duration-200
      ${selectedCategory?.name === item.name ? "bg-[#EDEDED] border-l-[2px] border-[#E63946]" : "hover:bg-[#F9FAFB]"}`}
                                >
                                    <div className="flex gap-2 md:gap-3 items-center">
                                        <div
                                            className={`text-[20px] ${selectedCategory?.name === item.name ? "text-[#E63946]" : "text-[#333333]"}`}
                                        >
                                            <HiOutlineDocumentText />
                                        </div>
                                        <div>
                                            {/* Main Category Name */}
                                            <p
                                                className={`text-[16px] font-[500] tracking-tight leading-tight ${selectedCategory?.name === item.name ? "text-[#E63946]" : "text-[#333333]"}`}
                                            >
                                                {item.name}
                                            </p>

                                            {/* Keywords / Subtitle (Ye line add karein) */}
                                            <p
                                                className={`text-[11px] font-[400] mt-1 line-clamp-1 ${selectedCategory?.name === item.name ? "text-[#E63946]" : "text-[#33333399]"}`}
                                            >
                                                {item.keywords.join(", ") ||
                                                    item.subtitle ||
                                                    "CGL, CHSL, MTS, Stenographer"}
                                            </p>
                                        </div>
                                    </div>
                                    <FiChevronRight
                                        className={`text-[16px] mt-1 transition-transform ${selectedCategory?.name === item.name ? "text-[#E63946] rotate-90" : "text-[#333333]"}`}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="lg:hidden w-full relative z-20">
                            <button
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                                className="w-full flex items-center justify-between bg-white border border-[#E63946] text-[#E63946] px-4 py-3 rounded-[8px] font-[500]"
                            >
                                <div className="flex items-center gap-2">
                                    <FiFilter />
                                    <span>Select Category: {selectedCategory?.name}</span>
                                </div>
                                <FiChevronDown
                                    className={`transition-transform ${isMobileMenuOpen ? "rotate-180" : ""}`}
                                />
                            </button>
                            {isMobileMenuOpen && (
                                <div className="absolute top-full left-0 w-full mt-2 bg-white border border-[#E0E0E0] rounded-[8px] shadow-xl max-h-[400px] overflow-y-auto">
                                    {categories.map((cat, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => {
                                                setSelectedCategory(cat);
                                                setIsMobileMenuOpen(false);
                                            }}
                                            className={`flex items-center gap-3 w-full px-5 py-3 text-left border-b border-[#F0F0F0] last:border-0
                                            ${selectedCategory?.name === cat.name ? "bg-[#FFF0F1] text-[#E63946]" : "text-[#333] hover:bg-gray-50"}`}
                                        >
                                            <span className="text-[14px] font-[500]">{cat.name}</span>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 p-3 md:mt-4">
                            {/* Loading State */}
                            {examLoading && (
                                <div className="col-span-full py-20 text-center text-gray-500">
                                    Loading exams...
                                </div>
                            )}

                            {/* No Data State - Design ke hisaab se clean message */}
                            {!examLoading && exams.length === 0 && (
                                <div className="col-span-full flex flex-col items-center justify-center py-20 bg-[#F9FAFB] rounded-[10px] border-2 border-dashed border-gray-200">
                                    <div className="text-[50px] mb-4 text-gray-300">
                                        <HiOutlineDocumentText />
                                    </div>
                                    <h3 className="text-[18px] font-[600] text-[#333333]">
                                        No Exams Found
                                    </h3>
                                    <p className="text-[14px] text-[#333333B2] mt-1">
                                        Humne is category mein abhi koi test add nahi kiya hai.
                                    </p>
                                </div>
                            )}

                            {/* Exams List - Design unchanged */}
                            {!examLoading &&
                                exams.length > 0 &&
                                exams.map((exam, i) => (
                                    <div
                                        key={exam._id}
                                        className="relative bg-[#E9F2FF] rounded-[5px] p-3 border border-transparent hover:border-[#3B82F6] transition flex flex-col h-full"
                                    >
                                        {/* Popular Tag */}
                                        {exam.isPopular && (
                                            <div className="absolute top-0 left-0 bg-[#21C11E] text-white text-[15px] font-[500] px-2 py-2 rounded-br-[5px] rounded-tl-[5px]">
                                                Most Popular
                                            </div>
                                        )}

                                        <div className="mt-10 mb-4">
                                            <h3 className="font-[500] text-[16px] text-[#333333]">
                                                {exam.testName}
                                            </h3>

                                            <p className="text-[12px] font-[500] text-[#333333B2] mt-2 leading-relaxed px-1">
                                                {exam.testYear} • {exam.difficulty?.toUpperCase()} •{" "}
                                                {exam.durationMinutes} mins
                                            </p>
                                        </div>

                                        <div className="flex justify-between text-center my-4 mt-auto">
                                            <div className="flex-1">
                                                <p className="font-[500] text-[#253D5F] text-[14px] tracking-tight">
                                                    {exam.totalSections}
                                                </p>
                                                <span className="text-[10px] font-[500] text-[#333333]">
                                                    Sections
                                                </span>
                                            </div>

                                            <div className="flex-1 border-x border-gray-200">
                                                <p className="font-[500] text-[#253D5F] text-[14px] tracking-tight">
                                                    {exam.totalQuestions}
                                                </p>
                                                <span className="text-[10px] font-[500] text-[#333333]">
                                                    Questions
                                                </span>
                                            </div>

                                            <div className="flex-1">
                                                <p className="font-[500] text-[#253D5F] text-[14px] tracking-tight">
                                                    {exam.durationMinutes}
                                                </p>
                                                <span className="text-[10px] font-[500] text-[#333333]">
                                                    Minutes
                                                </span>
                                            </div>
                                        </div>

                                        <button
                                            onClick={() => redirectToExam(exam)}
                                            className="w-full bg-[#4096F6] cursor-pointer hover:bg-[#2563EB] text-white py-2 tracking-tight rounded-[6px] font-[500] text-[16px] shadow-sm"
                                        >
                                            Start Preparation
                                        </button>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-12">
                <h2 className="text-[28px] font-[500] text-[#333333] mb-5 tracking-tightest font-poppins">
                    Your Enrolled Exams
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-10 gap-y-4">
                    {enrolledExams.map((exam, idx) => (
                        <div
                            key={idx}
                            className="flex items-center justify-between bg-[#E6F2FF] border border-[0.5px] border-[#000000] py-[15px] px-[16px] rounded-[10px] hover:bg-white hover:shadow-md hover:border-[#4299E1] cursor-pointer transition-all group"
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-[39px] h-[39px] flex items-center justify-center bg-white rounded-full shadow-sm p-[8px]">
                                    <img
                                        src={exam.icon}
                                        alt={exam.name}
                                        className="w-full h-full object-contain"
                                    />
                                </div>

                                <div className="flex flex-col leading-tight">
                                    <span className="text-[16px] font-[500] text-[#333333] group-hover:text-[#4299E1] transition-colors tracking-tight">
                                        {exam.name}
                                    </span>
                                    <span className="text-[16px] text-[#33333399] font-[400]">
                                        {exam.papers}
                                    </span>
                                </div>
                            </div>

                            <FiChevronRight size={20} className="text-[#333333]" />
                        </div>
                    ))}
                </div>
            </div>

            <div className="mb-12 bg-white rounded-[16px] p-8 flex flex-col md:flex-row items-center justify-between gap-10 shadow-sm border border-[#E0E0E0]">
                <div className="flex-1">
                    <h2 className="text-[28px] font-[500] text-[#333333] mb-3 tracking-tight font-inter">
                        Share Previous Year Papers with us!
                    </h2>
                    <p className="text-[18px] text-[#333333CC] mb-8 max-w-[650px] leading-relaxed font-[500] font-poppins tracking-tight">
                        To analyse the performance, difficulty level, cut-off and other
                        details of the exams, please share previous year papers with us.
                    </p>
                    <button className="bg-[#4096F6] text-white px-10 py-2 rounded-[6px] text-[18px] font-[500] hover:bg-[#3182CE] transition-colors shadow-md tracking-tight">
                        Upload Paper
                    </button>
                </div>
            </div>

            <div className="mb-10">
                <h2 className="text-[28px] font-[500] text-[#333333] mb-5 tracking-tightest font-poppins">
                    FAQs of Previous Year Papers
                </h2>
                <div className="bg-white rounded-[16px] p-4 md:p-7">
                    {faqs.map((question, idx) => (
                        <div
                            key={idx}
                            className="border-b border-[#333333CC] last:border-0"
                        >
                            <button
                                onClick={() => toggleFaq(idx)}
                                className="w-full flex justify-between items-center py-4 text-left group"
                            >
                                <span className="text-[18px] font-[500] text-[#33333399] group-hover:text-[#4299E1] transition-colors pr-6 tracking-tight">
                                    {question}
                                </span>
                                <div
                                    className={`min-w-[32px] h-[32px] rounded-full flex items-center justify-center transition-all ${openFaq === idx ? "bg-[#4299E1] text-white rotate-180" : "bg-[#4096F6] text-white"}`}
                                >
                                    <FiChevronDown className="text-[20px]" />
                                </div>
                            </button>
                            <div
                                className={`text-[16px] text-[#666] leading-relaxed overflow-hidden transition-all duration-300 ${openFaq === idx ? "max-h-[200px] pb-6 opacity-100" : "max-h-0 opacity-0"}`}
                            >
                                Solving previous year papers helps you understand the exam
                                pattern, difficulty level, and time management.
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PreviousYearPaper;
